/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {TagInstance} from "../models/tag-instance";
import {TagService} from "../services/tag.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class TagInstancesResolver implements Resolve<TagInstance[]> {

  constructor(
    private mTagService: TagService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<TagInstance[]> {
    try {
      return await this.mTagService.getAllTagInstances();
    } catch (error) {
      console.error("Problem resolving Tag Instances... Error: " + error, error);
    }
  }

}
